/**
 * 将站内上传文件地址统一到当前环境的后端域名（避免数据库里残留 localhost:9090 等导致图片 ERR_CONNECTION_REFUSED）
 */
function getApiBase() {
  return (process.env.VUE_APP_BASE_API || 'http://localhost:8080/api').replace(/\/$/, '')
}

function parseApiOriginAndPathPrefix() {
  const apiBase = getApiBase()
  try {
    const u = new URL(apiBase)
    const pathname = (u.pathname || '/').replace(/\/+$/, '') || '/api'
    return { origin: u.origin, pathPrefix: pathname.startsWith('/') ? pathname : `/${pathname}` }
  } catch {
    return { origin: '', pathPrefix: '/api' }
  }
}

export function resolveMediaUrl(src) {
  if (src == null) return src
  const s = String(src).trim()
  if (!s || s === 'undefined' || s === 'null') return ''
  if (s.startsWith('data:') || s.startsWith('blob:')) return s

  const { origin: apiOrigin, pathPrefix } = parseApiOriginAndPathPrefix()
  const apiBase = getApiBase()

  if (s.startsWith('/api/file/')) {
    return apiOrigin ? `${apiOrigin}${s}` : s
  }
  if (s.startsWith('/file/') && apiOrigin) {
    return `${apiOrigin}${pathPrefix}${s}`
  }
  if (/^api\/file\//i.test(s)) {
    return `${apiBase}/${s}`
  }
  if (!/^https?:\/\//i.test(s) && /^file\//i.test(s)) {
    return `${apiBase}/${s.replace(/^\//, '')}`
  }

  try {
    const abs = new URL(s)
    const local = abs.hostname === 'localhost' || abs.hostname === '127.0.0.1'
    const fileApi = /\/api\/file\//i.test(abs.pathname)
    if (local && fileApi && apiOrigin) {
      return `${apiOrigin}${abs.pathname}${abs.search || ''}`
    }
  } catch {
    /* 非绝对 URL */
  }

  return s
}

/** 浅层遍历系统配置等对象，修正其中的文件 URL 字符串 */
export function rewriteConfigMediaUrls(obj) {
  if (!obj || typeof obj !== 'object') return obj
  const out = Array.isArray(obj) ? [...obj] : { ...obj }
  for (const key of Object.keys(out)) {
    const v = out[key]
    if (typeof v !== 'string' || !v.trim()) continue
    const looksLikeMedia =
      /^https?:\/\//i.test(v) ||
      v.startsWith('/api/') ||
      v.startsWith('/file/') ||
      /^api\/file\//i.test(v) ||
      /^file\//i.test(v)
    if (!looksLikeMedia) continue
    const next = resolveMediaUrl(v)
    if (next !== v) out[key] = next
  }
  return out
}
